import analysisMapModule from "./analysisMapModule"
import angular from "angular"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"
import _ from "lodash"
import server from "../server"


analysisMapModule.controller("analysisMapController", [
    "$scope",
    "$modal",
    "$http",
    "loadingService",
    "organizeService",
    "messagesModal",
    "remoteExceptionHandler",
    "$q",
    "analysisMapService",
    "analysisMapPreViolationService",
    "markerService",
    "markerImage",
    "routeService",
    "detailsModal",
    "manualOperationOptionsModal",
    "manualOperationToTripModal",
    "nodeIdentifiers",
    "restrictionsModal",
    "nodeCommandStartMonitorableConfiguration",
    "supplyService",
    ($scope, $modal, $http, loadingService, organizeService, messagesModal, remoteExceptionHandler, $q, analysisMapService, analysisMapPreViolationService, markerService, markerImage, routeService, orderDetailsModal, manualOperationOptionsModal, manualOperationToTripModal, nodeIdentifiers, restrictionsModal, nodeCommandStartMonitorableConfiguration, supplyService) => {

        let baskets = {
            orders: null,
            trips: null
        }
        $scope.baskets = baskets
        $scope.selection = {
            deliveryUnits: {},
            tripBasket: {},
        }

        //Será populado na diretiva de seleção de tipos
        $scope.viewType = {}

        $scope.registerBasketApi = function (basketApiName, api) {
            baskets[basketApiName] = api
        }

        $scope.refilterBaskets = () => {
            baskets.trips.refreshFilter()
            baskets.orders.refreshFilter()
        }

        $scope.resume = function () {
            baskets.trips.refreshFilter()
        }
        $scope.$on("OnRouteColorChanged", function (event, changeColorData) {
            baskets.trips.changePresentationIconColor(changeColorData)
        })

        $scope.routes = []
        $scope.orderNodes = []
        $scope.orderMarkersHereHere = []
        $scope.routesMarkers = []
        $scope.selectedOrderMarkers = []
        $scope.tripStopMarkers = []
        $scope.routeNodes = []
        $scope.selectedMapStops = []
        $scope.isOrderCollapsed = false
        $scope.isTripCollapsed = true
        $scope.isTogglingOrdersInStop = false

        $scope.orderMaxPageSize = 50
        $scope.orderMaxPageSizes = [50, 100, 250, 500]
        $scope.tripMaxPageSize = 10
        $scope.tripMaxPageSizes = [10, 25, 50]

        let markersHereApi
        $scope.onRegisterMarkersHereApi = function (api) {
            markersHereApi = api
        }

        let routesHereApi
        $scope.onRegisterRoutesHereApi = function (api) {
            routesHereApi = api
            routesHereApi.setOnRouteSelect(function(trip) {
                $scope.baskets.trips.toggleSelection(trip.id, "Trip")
            })
        }


        $scope.getRoutes = function (rootNode) {
            $scope.routeNodes = rootNode.children
            loadingService(routeService.getRouteFromNodeIdentifiers(rootNode.children)
                .then(function (routes) {
                    $scope.routesHereMarkers = routes
                    routesHereApi.setRoutes($scope.routesHereMarkers)
                    routesHereApi.cleanMapRoutesMarkersSelection()
                    syncPresentationIconColor(routes)
                }))
        }

        function syncPresentationIconColor(routes){
            $scope.$applyAsync(function() {
                routes.forEach(function (route) {
                    let tripNode = _.find($scope.routeNodes, function(node) {
                        return node.id === route.presentationNode.id
                    })
                    if (tripNode && route.color) {
                        let colorData = {
                            presentationId: tripNode.presentationId,
                            color: route.color
                        }
                        $scope.baskets.trips.changePresentationIconColor(colorData)
                    }
                })
            })
        }

        $scope.$on("OnNodeSelected", function (event, minimalNode) {
            if (minimalNode.type.name.toLowerCase() !== "order") {
                return
            }
            if (minimalNode.parent.name.toUpperCase() === "ROUTING_BASKET") {
                if (minimalNode.selected) {
                    routesHereApi.cleanMapRoutesMarkersSelection()
                }
                let selectedOrderNodes = _.map($scope.selection.deliveryUnits.Order, function (orderNode) {
                    return orderNode.presentationId
                })
                let selectedOrderMarkers = _.map($scope.selectedOrderMarkers, function (orderMarker) {
                    return orderMarker.identifier
                })
                let sourceIdsToSelect = _.difference(selectedOrderNodes, selectedOrderMarkers)
                let sourceIdsToRemove = _.difference(selectedOrderMarkers, selectedOrderNodes)
                if (!_.isEmpty(sourceIdsToSelect)) {
                    let markersToSelectHere = _.filter($scope.orderMarkersHere, function (marker) {
                        return arrays.contains(sourceIdsToSelect, marker.data.identifier)
                    })
                    markersHereApi.toggleMapMarkers(markersToSelectHere)
                }
                if (!_.isEmpty(sourceIdsToRemove)) {
                    let markersToRemoveHere = _.filter($scope.orderMarkersHere, function (marker) {
                        return arrays.contains(sourceIdsToRemove, marker.data.identifier)
                    })
                    markersHereApi.toggleMapMarkers(markersToRemoveHere)
                }
            } else {
                if (minimalNode.selected) {
                    markersHereApi.cleanMapMarkersSelection()
                }
                if ($scope.isTogglingOrdersInStop) {
                    return
                }
                let selectedStopOrderNodes = _.map($scope.selection.tripBasket.Order, function (orderNode) {
                    return {
                        stopId: orderNode.$parent.id,
                        presentationNodeTripId: orderNode.$parent.$parent.id,
                        presentationId: orderNode.presentationId
                    }
                })
                let selectedStopOrderMarkers = _.map($scope.selectedMapStops, function (stopMap) {
                    return {
                        presentationNodeTripId: stopMap.tripId,
                        stopId: stopMap.stop.id,
                        orderSummaries: stopMap.stop.orderSummaries
                    }
                })
                orderSummariesStopsService(selectedStopOrderMarkers, selectedStopOrderNodes)

                let stopsToSelect = _.differenceBy(selectedStopOrderNodes, selectedStopOrderMarkers, "stopId")
                let stopsToDeselect = _.differenceBy(selectedStopOrderMarkers, selectedStopOrderNodes, "stopId")

                if (!_.isEmpty(stopsToSelect)) {
                    stopsToSelect.forEach(function (stop) {
                        routesHereApi.toggleRouteMarkersByModel([stop])
                    })
                }
                if (!_.isEmpty(stopsToDeselect)) {
                    stopsToDeselect.forEach(function (stop) {
                        routesHereApi.toggleRouteMarkersByModel([stop])
                    })
                }
            }
        })

        $scope.$watchCollection("selectedOrderMarkers", function () {
            let selectedOrderNodes = _.map($scope.selection.deliveryUnits.Order, function (orderNode) {
                return orderNode.presentationId
            })
            let selectedOrderMarkers = _.map($scope.selectedOrderMarkers, function (orderMarker) {
                return orderMarker.identifier
            })
            $scope.selectedOrderSummariesMarkers = $scope.selectedOrderMarkers.map(function (stopMap) {
                return stopMap.orderSummary
            })
            let sourceIdsToSelect = _.difference(selectedOrderMarkers, selectedOrderNodes)
            let sourceIdsToDeselect = _.difference(selectedOrderNodes, selectedOrderMarkers)
            if (!_.isEmpty(sourceIdsToSelect)) {
                sourceIdsToSelect.forEach(function (sourceId) {
                    let node = _.filter($scope.orderNodes, function (orderNode) {
                        return orderNode.presentationId === sourceId
                    })[0]
                    $scope.baskets.orders.toggleSelection(node.id, "Order")
                })
            }
            if (!_.isEmpty(sourceIdsToDeselect)) {
                sourceIdsToDeselect.forEach(function (sourceId) {
                    let node = _.filter($scope.orderNodes, function (orderNode) {
                        return orderNode.presentationId === sourceId
                    })[0]
                    $scope.baskets.orders.toggleSelection(node.id, "Order")
                })
            }
        })

        $scope.$watchCollection("selectedMapStops", function () {
            $scope.selectedStopNodes = []
            $scope.selectedStopOrderNodes = []
            $scope.selectedStopsMarkers = []

            $scope.selectedStopsMarkers = _.map($scope.selectedMapStops, function (stopMap) {
                return {
                    presentationNodeTripId: stopMap.tripId,
                    stopId: stopMap.stop.id,
                    orderSummaries: stopMap.stop.orderSummaries
                }
            })
            $scope.selectedStopOrderNodes = _.map($scope.selection.tripBasket.Order, function (orderNode) {
                return {
                    id: orderNode.id,
                    presentationNodeTripId: orderNode.$parent.$parent.id,
                    stopId: orderNode.$parent.id,
                    presentationId: orderNode.presentationId
                }
            })

            orderSummariesStopsService($scope.selectedStopsMarkers, $scope.selectedStopOrderNodes)

            $scope.selectedStopNodes = _.uniqBy($scope.selectedStopOrderNodes, "stopId")

            let stopsToSelect = _.differenceBy($scope.selectedStopsMarkers, $scope.selectedStopNodes, "stopId")
            let stopsToDeselect = _.differenceBy($scope.selectedStopNodes, $scope.selectedStopsMarkers, "stopId")

            if (!_.isEmpty(stopsToSelect)) {
                $scope.isTogglingOrdersInStop = true
                toggleOrdersStopSelection(stopsToSelect)
            }
            if (!_.isEmpty(stopsToDeselect)) {
                $scope.isTogglingOrdersInStop = true
                removeOrdersStopSelection(stopsToDeselect)
            }
        })

        function toggleOrdersStopSelection(stops) {
            stops.forEach(function (stopMarker) {
                let node = _.filter($scope.routeNodes, function (routeNode) {
                    return routeNode.id === stopMarker.presentationNodeTripId
                })[0]
                $scope.baskets.trips.expandOrCollapse(node).then(function () {
                    let stopNode = _.filter(node.children, function (stop) {
                        return stop.id === stopMarker.stopId
                    })[0]
                    stopNode.children.forEach(function (orderNode) {
                        $scope.baskets.trips.toggleSelectionAllLevel(orderNode.id, "Order", orderNode.$parent.id)
                    })
                })
            })
            $scope.isTogglingOrdersInStop = false
        }

        function orderSummariesStopsService(selectedStopMarkers, selectedStopOrderNodes) {
            let stopMarkers = angular.copy(selectedStopMarkers) || []
            let stopOrderNodes = angular.copy(selectedStopOrderNodes) || []
            let orderSummaries = []
            let stopAlreadySelectedInTripBasket = _.remove(stopMarkers, function (stopMarker) {
                return _.some(stopOrderNodes, {stopId: stopMarker.stopId})
            })

            _.flatMap(stopAlreadySelectedInTripBasket, stop => stop.orderSummaries).forEach(
                function (orderSummary) {
                    stopOrderNodes.forEach(function (stopOrderNode) {
                        if (orderSummary.orderSourceId === stopOrderNode.presentationId) {
                            orderSummaries.push(orderSummary)
                        }
                    })
                }
            )

            _.flatMap(stopMarkers, stop => stop.orderSummaries).forEach(
                function (orderSummary) {
                    orderSummaries.push(orderSummary)
                }
            )

            $scope.selectedOrderSummariesStopsMarkers = _.uniqBy(orderSummaries, "orderSourceId")
        }

        function removeOrdersStopSelection(stopsToDeselect) {
            stopsToDeselect.forEach(function (stop) {
                let stopOrdersToDeselect = _.filter($scope.selectedStopOrderNodes, function (stopOrderNode) {
                    return stopOrderNode.stopId === stop.stopId
                })
                stopOrdersToDeselect.forEach(function (stopOrder) {
                    $scope.baskets.trips.toggleSelectionAllLevel(stopOrder.id, "Order", stopOrder.stopId)
                })
            })
            $scope.isTogglingOrdersInStop = false
        }

        $scope.getMarkers = function (ordersRootNode) {
            $scope.orderNodes = ordersRootNode.children
            let orderSourceIds = _.map($scope.orderNodes, function (node) {
                return node.presentationId
            })
            analysisMapService.findMarkers(orderSourceIds)
                .then(function (markersToValidate) {
                    let validMarkers = validateAndRemoveMarkersWithoutGeographicInfo(markersToValidate)
                    $scope.orderMarkersHere = buildMarkersHere(validMarkers)
                    markersHereApi.cleanMapMarkersSelection()
                })
        }

        $scope.$on("OnMapMarkerAction", function (event, dataToDoManualOperation) {
            if (dataToDoManualOperation) {
                let filteredRoutes = _.filter($scope.routes, function (route) {
                    return arrays.contains(dataToDoManualOperation.tripCodes, route.tripCode)
                })
                let orderNodes = _.filter($scope.orderNodes, function (orderNode) {
                    return arrays.contains(dataToDoManualOperation.orderCodes, orderNode.presentationId)
                })
                let orderItemNodes = _.flatMap(orderNodes, function (orderNode) {
                    return _.map(orderNode.children, function (orderItemNode) {
                        return orderItemNode
                    })
                })
                let manualOperationTemplate = getManualOperationTemplate(orderItemNodes)
                if (filteredRoutes.length === 1) {
                    return $scope.doManualOperation(manualOperationTemplate, filteredRoutes[0].presentationNode)
                }
                return $scope.getSelectedTripToOperation(filteredRoutes).then((trip) => {
                    return $scope.doManualOperation(manualOperationTemplate, trip)
                })
            }
        })

        function validateAndRemoveMarkersWithoutGeographicInfo(markers) {
            let validMarkers = []
            let invalidMarkers = []
            markers.forEach(marker => {
                if ($scope.isValidGeographicInfo(marker.geographicInfo)) {
                    return validMarkers.push(marker)
                }
                return invalidMarkers.push(marker)
            })
            if (invalidMarkers.length > 0) {
                let orderSourceIds = getOrderSourceIds(invalidMarkers)
                messagesModal("dialog.warning", [{
                    keyBundle: "analysis.map.markers.without.geographicInfo",
                    parameters: [orderSourceIds]
                }])
            }
            return validMarkers
        }

        $scope.isValidGeographicInfo = (geographicInfo) => {
            if (geographicInfo) {
                return $scope.isValidLatitudeLongitude(geographicInfo)
            }
            return false
        }

        $scope.isValidLatitudeLongitude = (geographicInfo) => {
            return !!(geographicInfo.latitude && geographicInfo.longitude)
        }

        function getOrderSourceIds(invalidMarkers) {
            return invalidMarkers.reduce((accumulator, marker) => {
                return accumulator + marker.orderSummary.orderSourceId + ", "
            }, "")
        }

        function buildMarkersHere(orderMarkers) {
            const markers = []
            let duIdsByOrderSourceId = getDuIdsByOrderSourceId()
            orderMarkers.forEach(function (orderMarker) {
                let markerHere =  {
                    geographicInfo: orderMarker.geographicInfo,
                    data: {
                        id: orderMarker.sourceId,
                        identifier: orderMarker.sourceId,
                        icon: "images/marker-pin.png",
                        key: orderMarker.markerKey,
                        geographicInfo: orderMarker.geographicInfo,
                        orderSummary : orderMarker.orderSummary,
                        order: orderMarker,
                        duId: duIdsByOrderSourceId[orderMarker.sourceId],
                    }
                }
                markers.push(markerHere)
            })
            return markers
        }

        function getDuIdsByOrderSourceId() {
            var duIdsByOrderSourceId = {}
            $scope.orderNodes.forEach(function(node) {
                duIdsByOrderSourceId[node.presentationId] = node.children.map(function(child) {
                    return child.id
                })
            })
            return duIdsByOrderSourceId
        }

        $scope.showMoreDetails = function () {
            loadingService(analysisMapService.getOrdersDetails(getSelectedOrdersSourceIds()))
                .then((response) => {
                    orderDetailsModal(response)
                }).catch(remoteExceptionHandler())
        }

        $scope.cleanSelection = function () {
            messagesModal.cancellable("dialog.proceed?", [{
                keyBundle: "analysis.map.dialog.clean.selection.confirmation"
            }]).then(() => {
                if ($scope.hasSelectedOrderMarkers()) {
                    return markersHereApi.cleanMapMarkersSelection()
                }
                return routesHereApi.cleanMapRoutesMarkersSelection()
            })
        }

        $scope.selectAllMarkers = function () {
            if (_.isEqual(_.sortBy($scope.selectedOrderMarkers), _.sortBy($scope.orderMarkersHere))) {
                messagesModal("dialog.success", [{
                    keyBundle: "analysis.map.dialog.select.all.already.done"
                }])
                return
            }
            messagesModal.cancellable("dialog.proceed?", [{
                keyBundle: "analysis.map.dialog.select.all.confirmation"
            }]).then(() => {
                markersHereApi.selectAllMapMarkers()
            })
        }

        $scope.$watchCollection("orderMarkers", function () {
            if (!_.isEmpty($scope.orderMarkersHere)) {
                markersHereApi.centerAllMarkers()
            }
        })

        $scope.centerOnSelectedMarkers = function () {
            if (!_.isEmpty($scope.selectedOrderMarkers)) {
                markersHereApi.centerOnSelectedMapMarkers()
            }
        }

        $scope.openSuccessMessageModal = function (message) {
            return messagesModal("dialog.success", [message])
        }

        $scope.optimizeWithRestrictions = () => {
            let dusId = $scope.selection.deliveryUnits.DeliveryUnit.map(du => du.id)
            loadingService(
                $q.all([
                    $http.get(server.getServiceUrl("vehicleFindAll")),
                    $http.post(server.getServiceUrl("getOriginsToOptimizeWithRestrictions"),
                        {
                            "tripsId": [],
                            "ordersId": dusId
                        }
                    )])
            ).then(function (response) {
                return restrictionsModal(response[0].data, response[1].data).then(restrictions => $scope.doOptimization(restrictions))
            })
        }

        function doOptimize(restrictions) {
            if (restrictions) {
                return loadingService(
                    analysisMapService.doOptimizeWithRestrictions(getNodeIds($scope.selection.deliveryUnits.DeliveryUnit), restrictions)
                )
            }
            return loadingService(
                analysisMapService.doOptimize(getNodeIds($scope.selection.deliveryUnits.DeliveryUnit))
            )
        }

        $scope.doOptimization = function (restrictions) {
            messagesModal.cancellable("dialog.proceed?", [{
                keyBundle: "analysis.map.dialog.optimize.confirmation"
            }]).then(() => {
                analysisMapPreViolationService.getViolationsForOptimization(getNodeIds($scope.selection.deliveryUnits.DeliveryUnit))
                    .then(() => {
                        return doOptimize(restrictions)
                    }).catch(remoteExceptionHandler())
                    .then(() => {
                        markersHereApi.cleanMapMarkersSelection()
                        routesHereApi.cleanMapRoutesMarkersSelection()
                        return $scope.openSuccessMessageModal({
                            keyBundle: "programming.optimization.successful.submit"
                        }).then(() => {
                            $scope.refilterBaskets()
                        })
                    })
            })
        }

        $scope.manualOperations = function () {
            $scope.getChosenOperation()
                .then((chosenOperation) => {
                    switch (chosenOperation) {
                        case "TRIP":
                            if (!$scope.routes || _.isEmpty($scope.routes)) {
                                messagesModal("dialog.warning", [{
                                    keyBundle: "analysis.map.manual.operation.toTrip.no.filtered.trips"
                                }])
                                return
                            }
                            return $scope.getSelectedTripToOperation($scope.routes).then((trip) => {
                                return $scope.doManualOperation($scope.selection, trip)
                            })
                        default:
                            return $scope.doManualOperation($scope.selection, $scope.baskets.trips.getData())
                    }
                })
        }

        $scope.removeOrdersFromTrip = function () {
            return $scope.doManualOperation($scope.selection, $scope.baskets.orders.getData())
        }

        $scope.getChosenOperation = function () {
            return manualOperationOptionsModal().result.then(function (result) {
                return result.chosenOperation
            })
        }

        $scope.getSelectedTripToOperation = function (routes) {
            return manualOperationToTripModal(routes).result.then(function (result) {
                return result.selectedTripNode
            })
        }

        $scope.doManualOperation = function (manualOperationSelection, target) {
            organizeService.organize(
                manualOperationSelection,
                target
            ).then(() => {
                $scope.refilterBaskets()
            })
        }

        $scope.onDropOnBasket = function (dropInfo) {
            organizeService.organize($scope.selection, dropInfo.toNode).then(function () {
                return $scope.refilterBaskets()
            })
        }

        $scope.getSelectedOrdersFromTripBasket = () => {
            return nodeIdentifiers.toNodeIdentifiers($scope.selection.tripBasket.DeliveryUnit || [])
        }

        $scope.preventClick = (condition, callback) => {
            if (condition) {
                return callback()
            }
            return false
        }

        $scope.hasSelectedOrderInSomeSelection = () => {
            if ($scope.hasSelectedOrderMarkers()) {
                return false
            }
            if ($scope.hasSelectedStopMarkers()) {
                return false
            }
            return true
        }

        $scope.hasSelectedOrderMarkers = () => {
            return $scope.selectedOrderMarkers.length
        }

        $scope.hasSelectedStopMarkers = () => {
            return $scope.selectedStopsMarkers.length
        }

        $scope.getSelectedTrips = () => {
            return nodeIdentifiers.toNodeIdentifiers($scope.selection.tripBasket.Trip || [])
        }

        $scope.startMonitorableView = () => {
            nodeCommandStartMonitorableConfiguration($scope.getSelectedTrips())
        }

        $scope.$watchCollection("selection.tripBasket.Trip", function (selectedTrips) {
            if (routesHereApi && routesHereApi.syncRoutesOpacityWithSelection) {
                let selectedTripIds = _.map(selectedTrips, function (tripNode) {
                    return tripNode.id
                })
                routesHereApi.syncRoutesOpacityWithSelection(selectedTripIds)
            }
        })

        supplyService.registerInitialSearchWatch($scope, $scope.baskets)

        function getNodeIds(nodes) {
            return nodeIdentifiers.toNodeIdentifiers(nodes || []).map(function (node) {
                return node.id
            })
        }

        function getSelectedOrders() {
            if ($scope.hasSelectedOrderMarkers()) {
                return $scope.selectedOrderSummariesMarkers
            }
            return $scope.selectedOrderSummariesStopsMarkers
        }

        function getSelectedOrdersSourceIds() {
            return _.map(getSelectedOrders(), function (marker) {
                return marker.orderSourceId
            })
        }

        function getManualOperationTemplate(orderItemNodes) {
            return {
                deliveryUnits: {
                    DeliveryUnit: formatNodeIdsToDoManualOperation(getNodeIds(orderItemNodes)),
                    Order: []
                },
                tripBasket: {}
            }
        }

        function formatNodeIdsToDoManualOperation(idsToDoManualOperation) {
            let formattedData = []
            _.forEach(idsToDoManualOperation, function (id) {
                formattedData.push({
                    id: id,
                    type: {
                        messageKey: "presentationnode.nodetype.delivery.unit",
                        name: "DeliveryUnit"
                    },
                    $parent: {
                        type: {
                            messageKey: "presentationnode.nodetype.routingBasket",
                            name: "ROUTING_BASKET"
                        }
                    }
                })
            })
            return formattedData
        }

    }])
